import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deleteText } from './../../../redux/actions/entities/texts';
import './DeleteBtn.css';
import { saveState } from '../../../redux/actions/entities/io';

class DeleteBtn extends Component {
  handleClick = () => {
    const { textFieldId } = this.props;
    this.props.dispatch(deleteText(textFieldId));
    this.props.dispatch(saveState());
  }

  render() {
    return (
      <div className="col">
        <button className="btn green-btn delete-text-btn" onClick={this.handleClick}>
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16"><path d="M10,2V1A1,1,0,0,0,9,0H4A1,1,0,0,0,3,1V2H0V3H1V14a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2V3h1V2ZM4,1H9V2H4ZM4,14H3V4H4Zm3,0H6V4H7Zm3,0H9V4h1Z" /></svg>
          Szöveg törlése
        </button>
      </div>
    );
  }
}

DeleteBtn.defaultProps = {
  textFieldId: 0,
};

DeleteBtn.propTypes = {
  textFieldId: PropTypes.number,
};

export default connect()(DeleteBtn);



// WEBPACK FOOTER //
// ./src/components/text-tools/delete-btn/DeleteBtn.jsx